/// <amd-module name="SuiteCommerce.StockNotifications.PDP.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.PDP.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PdpModel = /** @class */ (function (_super) {
        __extends(PdpModel, _super);
        function PdpModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(PdpModel.prototype, "isAccordionOpen", {
            get: function () {
                return this.get('accordionOpen') || false;
            },
            enumerable: true,
            configurable: true
        });
        PdpModel.prototype.toggleAccordion = function () {
            this.set('accordionOpen', !this.get('accordionOpen'));
        };
        Object.defineProperty(PdpModel.prototype, "isSubscribeToAll", {
            get: function () {
                return this.get('subscribeToAll') || false;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PdpModel.prototype, "subscribeToAll", {
            set: function (state) {
                this.set('subscribeToAll', state);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PdpModel.prototype, "itemsIds", {
            get: function () {
                return this.get('itemsIds') || "";
            },
            set: function (items) {
                this.set('itemsIds', items);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PdpModel.prototype, "isMatrixItem", {
            get: function () {
                return this.get('isMatrixItem') || false;
            },
            set: function (isMatrixItem) {
                this.set('isMatrixItem', isMatrixItem);
            },
            enumerable: true,
            configurable: true
        });
        PdpModel.prototype.setFilteredOutOfStockItemsIds = function (items) {
            this.itemsIds = this.filterOutOfStockItems(items).join(',');
        };
        PdpModel.prototype.filterOutOfStockItems = function (items) {
            var filteredOutOfStockItems = [];
            if (items) {
                items.forEach(function (item) {
                    if (!item.isinstock) {
                        filteredOutOfStockItems.push(item.internalid);
                    }
                });
            }
            return filteredOutOfStockItems;
        };
        return PdpModel;
    }(Backbone_1.Model));
    exports.PdpModel = PdpModel;
});
